import faker from "@faker-js/faker";
import { Asset } from "@src/core/models/asset";

export const mockAsset = (overrides?: Asset): Asset => ({
  createdAt: faker.date.past(),
  createdBy: faker.datatype.uuid(),
  available: true,
  editionId: "1",
  id: "d3f14330-93dc-420e-a156-6a41d6422ae9",
  mediaUrl: "https://gigaland.io/images/carousel/crs-5.jpg",
  ipfsMetadata: "https://gigaland.io/images/carousel/crs-5.jpg",
  updatedAt: faker.date.past(),
  updatedBy: faker.datatype.uuid(),
  ...(overrides || {}),
});
